<template>
  <div class="perf-order-nchart-widget__wrapper" style="height: 100%; width: 100%;">
    <highcharts v-if="isEmptyData" style="height: 100%; width: 100%;" class="fit-highchart" :options="options" ref="highchart" />
  </div>
</template>

<script>
import { pieOptions } from '@/constants/chart-options';

import { isEmpty } from '@/utils/basic';

export default {
  name: 'WSolidGaugeChart',
  props: {
    title: {
      type: String,
      ddfualt: '',
    },
  },
  data() {
    return {
      objtypeId: '',
      options: {},
      chartData: [],
      customLegendOptions: {},
      fontSize: '14px',
      isEmptyData: false,
    };
  },
  computed: {
    /**
     * 차트 타입에 해당하는 차트 옵션 반환
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    chartOptions() {
      return pieOptions;
    },
    /**
     * 대시보드 테마
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    dashboardTheme() {
      return this.$store.getters.getDashboardTheme;
    },
  },
  watch: {
    dashboardTheme: {
      immediate: true,
      handler(val) {
        if (!isEmpty(val)) {
          this.setData(this.chartData);
          this.$nextTick(() => {
            // point.redraw();
          });
        }
      },
    },
  },
  methods: {
    setData(data, objtypeId) {
      this.isEmptyData = !isEmpty(data.seriesData) && data.seriesData.length > 0;
      this.$nextTick(() => {
        this.objtypeId = objtypeId;
        this.chartData = data;
        if (!isEmpty(data)) {
          this.options = this.customChartOptions(data);
          this.options.series = [{
            data: data.seriesData,
          }];
        }
      });
    },
    customChartOptions(data) {
      const chartOptions = {};
      chartOptions.plotOptions = {
        solidgauge: {
          dataLabels: {
            // format: '<span style="font-size: 26px; font-weight: normal;">{point.convertValue}</span>',
            formatter() {
              const fontSize = (this.series.data.length > 1) ? 12 : 15;
              let formatStr = '';
              if (this.series.data.length > 1) {
                if (this.series.data[0].options.ioType === 'in') {
                  formatStr = `<span style="font-size: ${fontSize}px; font-weight: bold;">${this.series.data[0].options.convertValue}</span>`;
                  formatStr += `<span style="font-size: 4px; font-weight: normal;">(${this.series.data[0].options.ioType})</span>`;
                  formatStr += `<br /><span style="font-size: ${fontSize}px; font-weight: bold;">${this.series.data[1].options.convertValue}</span>`;
                  formatStr += `<span style="font-size: 4px; font-weight: normal;">(${this.series.data[1].options.ioType})</span>`;
                } else {
                  formatStr = `<span style="font-size: ${fontSize}px; font-weight: bold;">${this.series.data[1].options.convertValue}</span>`;
                  formatStr += `<span style="font-size: 4px; font-weight: normal;">(${this.series.data[1].options.ioType})</span>`;
                  formatStr += `<br /><span style="font-size: ${fontSize}px; font-weight: bold;">${this.series.data[0].options.convertValue}</span>`;
                  formatStr += `<span style="font-size: 4px; font-weight: normal;">(${this.series.data[0].options.ioType})</span>`;
                }
              } else {
                formatStr = `<span style="font-size: ${fontSize}px; font-weight: bold;">${this.series.data[0].options.convertValue}</span>`;
              }
              return formatStr;
              // return 'sss';
            },
            align: 'center',
            verticalAlign: 'middle',
            enabled: true,
            className: 'vmdetail-solidgauge-datalabels ',
            y: 0,
            // y: (data.seriesData.length > 1) ? 0 : -2,
            borderWidth: 0,
            useHTML: true,
            color: '#666',
          },
          linecap: 'round',
          stickyTracking: false,
          rounded: true,
        },
      };
      // chartOptions.tooltip = {
      //   borderWidth: 0,
      //   color: '#666',
      //   backgroundColor: 'none',
      //   shadow: false,
      //   style: {
      //     fontSize: '16px',
      //   },
      //   pointFormat: '<div style="font-size: 12px; font-weight: normal; text-align: center;">{point.convertValue}</div><br/><div style="font-size: 8px; font-weight: normal;">{point.label}</div>',
      //   // pointFormat: '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}%</span>',
      //   // positioner: (labelWidth, labelHeight, point) => {
      //   //   return {
      //   //     x: point.plotX / 2,
      //   //     y: point.plotY / 2,
      //   //     // x: (chart.chartWidth - labelWidth) / 2,
      //   //     // y: (chart.plotHeight / 2) + 15,
      //   //   };
      //   // },
      //   positioner: (labelWidth, labelHeight, point) => ({ x: point.plotX / 2, y: (point.plotY / 2) + 5 }),
      // };
      chartOptions.chart = {
        type: 'solidgauge',
        margin: [0, 10, 30, 0],
        // height: 200,
        // width: this.objtypeId === 'VVM' ? 150 : 200,
      };
      chartOptions.tooltip = {
        enabled: false,
      };
      chartOptions.credits = {
        enabled: false,
      };
      chartOptions.title = {
        text: `<span style="font-size: 10.5px;">${this.title}</span>`,
        floating: false,
        align: 'center',
        style: {
          color: '#666',
        },
        useHTML: true,
        y: 120,
      };
      chartOptions.yAxis = {
        min: 0,
        max: 100,
        // max: (!isEmpty(data.maxValue)) ? data.maxValue : 100,
        lineWidth: 0,
        tickPositions: [],
      };
      chartOptions.chart.spacing = [0, 0, 0, 0];
      chartOptions.pane = data.pane;
      // chartOptions.pane = {
      //   startAngle: 0,
      //   endAngle: 360,
      //   background: [{ // Track for Move
      //     outerRadius: '110%',
      //     innerRadius: '88%',
      //     backgroundColor: '#f4f4f5',
      //     borderWidth: 0,
      //   },
      //   { // Track for Move
      //     outerRadius: '85%',
      //     innerRadius: '63%',
      //     backgroundColor: '#f4f4f5',
      //     borderWidth: 0,
      //   }],
      // };
      return chartOptions;
    },
    resize() {
      this.$refs.highchart.chart.reflow();
    },
  },
};
</script>
<style>
.vmdetail-solidgauge-datalabels span{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/grid/view/components/SolidGaugeChart.vue